import React, {Component} from 'react'
import {connect} from 'react-redux';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  InfoWindow,
  Marker
} from "react-google-maps";
import * as residentialAreaAction from '../../actions/residentialAreaAction';
import {withTranslation} from 'react-i18next';

const MapWithPopupGoogleMap = withScriptjs(withGoogleMap(props => (
  <GoogleMap
    defaultZoom={13}
    center={props.center}
  >
    {props.markers.map((marker, index) => (
      <Marker
        key={index}
        icon={marker.icon}
        position={marker.position}
        onClick={() => props.onMarkerClick(marker)}
      >
        {/*
				 Show info window only if the 'showInfo' key of the marker is true.
				 That is, when the Marker pin has been clicked and 'onCloseClick' has been
				 Successfully fired.
				 */}
        {marker.showInfo && (
          <InfoWindow onCloseClick={() => props.onMarkerClose(marker)}>
            <div>{marker.infoContent}</div>
          </InfoWindow>
        )}
      </Marker>
    ))}
  </GoogleMap>
)))

@connect(
  state => ({ // mapStateToProps
    residentialAreas: state.residentialArea.all
  }),
  {
    fetchResidentialAreas: residentialAreaAction.fetchAll,
  }
)

@withTranslation()

export default class MapWithPopUp extends Component {

  /**
   * @param {object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      center: {
        lat: 47.054,
        lng: 8.30,
      },

      // array of objects of markers
      markers: [],

      // consent to display GoogleMaps content
      hasConsent: sessionStorage.getItem("googleMapsConsent") ? sessionStorage.getItem("googleMapsConsent") : false
    };

    this.handleMarkerClick = this.handleMarkerClick.bind(this)
    this.handleMarkerClose = this.handleMarkerClose.bind(this)
    this.setConsent = this.setConsent.bind(this)
    this.renderMap = this.renderMap.bind(this)
    this.renderConsentMessage = this.renderConsentMessage.bind(this)
  }

  /**
   * @return void
   */
  componentDidMount() {
    this.props.fetchResidentialAreas()
      .then(residentialAreas => {
        const markers = []

        residentialAreas.map((residentialArea => {
          const latitude = Number(residentialArea.coordinates && residentialArea.coordinates.latitude);
          const longitude = Number(residentialArea.coordinates && residentialArea.coordinates.longitude);

          if (!isNaN(latitude) && !isNaN(longitude)) {
            const marker = {
              position: {
                lat: latitude,
                lng: longitude
              },
              icon: residentialArea.numberOfCallForApplicationItems > 0 ? "/_Resources/Static/Packages/Visol.AblCh/Images/Maps/PlaceMarkRed.png" : "/_Resources/Static/Packages/Visol.AblCh/Images/Maps/PlaceMarkBlack.png",
              showInfo: false,
              infoContent: (
                  <div className="residentialArea__marker__infoWindow">
                    <div className="title">
                      <a href={residentialArea.uri}>{residentialArea.title}</a>
                    </div>
                    {residentialArea.thumbnail && residentialArea.thumbnail.src &&
                        <div>
                          <a href={residentialArea.uri}><img src={residentialArea.thumbnail.src}
                                                             alt=""
                                                             width="200"/></a>
                        </div>
                    }
                    {residentialArea.numberOfCallForApplicationItems >= 1 &&
                        <div className="availability">
                          <a href="#callForApplicationItems__filter" onClick={(e) => {
                            e.nativeEvent.stopPropagation()
                            this.props.handleFilterResidentialAreaChange(residentialArea.residentialAreaIdentifier)
                          }
                          } style={{color: 'white'}}>
                            Im Moment {residentialArea.numberOfCallForApplicationItems} freie&nbsp;
                            {residentialArea.numberOfCallForApplicationItems === 1
                                ? 'Wohnung.'
                                : 'Wohnungen.'
                            }
                          </a>
                        </div>
                    }
                  </div>
              )
            }
            markers.push(marker)
          }
        }))

        this.setState({markers: markers})
      })
  }

  // Toggle to 'true' to show InfoWindow and re-renders component
  handleMarkerClick(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: true,
          };
        }
        return marker;
      }),
    })
  }

  handleMarkerClose(targetMarker) {
    this.setState({
      markers: this.state.markers.map(marker => {
        if (marker === targetMarker) {
          return {
            ...marker,
            showInfo: false,
          };
        }
        return marker;
      }),
    })
  }

  setConsent() {
    sessionStorage.setItem("googleMapsConsent", "true");
    this.setState({hasConsent: true})
  }

  renderConsentMessage() {
    const {t} = this.props;

    return (
      <div className="privacy-consent google-maps-privacy">
        <h3>
          {t('googleMaps.consentMessage.title')}
        </h3>
        <p className='consent-text'>
          {t('googleMaps.consentMessage.paragraph1')}
        </p>
        <p className='consent-text'>
          {t('googleMaps.consentMessage.paragraph2')}
        </p>
        <button className="privacy-consent-button"
                onClick={this.setConsent}
        >
          {t('googleMaps.consentMessage.buttonLabel')}
        </button>
        <details>
          <summary className='consent-text'>
            {t('googleMaps.consentMessage.detail.summary')}
          </summary>
          <p className='consent-text'>
            {t('googleMaps.consentMessage.detail.paragraph1')}
          </p>
          <p className='consent-text'>
            {t('googleMaps.consentMessage.detail.paragraph2')}
          </p>
          <p className='consent-text'>
            {t('googleMaps.consentMessage.detail.paragraph3')}
            <a className="policy-link" href="/datenschutz" target="_blank">
              {t('googleMaps.consentMessage.detail.policy')}
            </a>
            .
          </p>
        </details>
      </div>
    );
  }

  renderMap() {
    return (
      <MapWithPopupGoogleMap
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCuioUWDETqArcmlrHSaQ1ssUSgNEaGLF8"
        loadingElement={
          <div className="residentialMarket__mapContainer"/>
        }
        containerElement={
          <div className="residentialMarket__mapContainer"/>
        }
        mapElement={
          <div className="residentialMarket__map"/>
        }
        center={this.state.center}
        markers={this.state.markers}
        onMarkerClick={this.handleMarkerClick}
        onMarkerClose={this.handleMarkerClose}
      />
    )
  }

  render() {
    // We don't want the maps to be loaded if we are in the context of residential area.
    if (AblCh.showForResidentialArea > 0) {
      return null
    }

    if (this.state.hasConsent) {
      return this.renderMap();
    } else {
      return this.renderConsentMessage();
    }
  }
}
